// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define;
let is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['react', 'lodash4', '/util/string.js', '/www/lum/pub/util/general.js',
    '/www/lum/pub/util/react.js', '/www/util/pub/react_hooks.js',
    '/util/date.js', '/util/etask.js', 'classnames', '/www/lum/pub/comp/ga.js',
    // Import only
    'css!/www/lum/pub/css/zbtn'],
    (React, _, string, general_util, react_util, react_hooks, date, etask,
    classnames, ga)=>
{
const {qw} = string;
const {get_classname} = general_util;
const {get_btn_comp} = react_util;
const {assign} = Object;
const {use_effect, use_etask, use_state, use_ref, use_memo} = react_hooks;
const E = {};

const zbtn_classes = qw`small medium large mini
inverse transparent_light light keep_color pulse wide full_width bold
disabled link_light danger no_pulse link navy processing secondary
cta_arrow_right animate_ball is_hover no_padding grey success
transparent_grey round`;
const Zbtn = React.forwardRef(function Zbtn(props, ref){
    let [animate, set_animate] = use_state(false);
    let etask_hook = use_etask();
    let {width, children, classes, disabled, hard_disabled, style = {},
        animated, delay, ...rest} = props;
    classes = classnames(classes, {
        'pulse': animate,
        'animated': animate,
        'zbtn_inverse': animate && !rest.keep_color,
    });
    let [is_hover, set_is_hover] = use_state();
    let classname = get_classname('zbtn', classes, zbtn_classes,
        assign({disabled, is_hover}, rest));
    rest.onClick = ga.hook_fn(rest.onClick, 'zbtn_click', props,
        {skip: disabled});
    rest.onMouseEnter = ga.hook_fn(rest.onMouseEnter, 'zbtn_hover', props);
    if (width)
        style.width = width;
    use_effect(()=>{
        if (!animated)
            return;
        etask_hook([()=>etask.sleep(delay||2*date.ms.SEC),
            ()=>set_animate(true), ()=>etask.sleep(date.ms.SEC),
            ()=>set_animate(false)]);
    }, [animated]);
    let container_ref = use_ref();
    let ball_ref = use_ref();
    React.useImperativeHandle(ref, ()=>container_ref.current);
    let on_mouse_enter = e=>{
        rest.onMouseEnter&&rest.onMouseEnter(e);
        adjust_ball_position(e);
        set_is_hover(true);
    };
    let on_mouse_leave = e=>{
        rest.onMouseLeave&&rest.onMouseLeave(e);
        adjust_ball_position(e);
        set_is_hover(false);
    };
    let adjust_ball_position = e=>{
        if (!rest.animate_ball || !container_ref.current || !ball_ref.current)
            return;
        let left, top, rect;
        rect = container_ref.current.getBoundingClientRect();
        left = e.clientX-rect.x;
        top = e.clientY-rect.y;
        ball_ref.current.style.left = `${left}px`;
        ball_ref.current.style.top = `${top}px`;
    };
    let Btn_comp = get_btn_comp(props);
    if (rest.cta_arrow_right)
    {
        children = <React.Fragment>
          {children}
          <svg className="cta_ic" viewBox="0 0 10 10">
            <g fillRule="evenodd">
              <path className="cta_ic-line_path" d="M0 5h7"/>
              <path className="cta_ic-tip_path" d="M1 1l4 4-4 4"/>
            </g>
          </svg>
        </React.Fragment>;
    }
    if (rest.animate_ball)
    {
        children = <React.Fragment>
          <span className="zbtn-content">{children}</span>
          <div className="zbtn-bg">
            <div className="animate_ball" ref={ball_ref}/>
          </div>
        </React.Fragment>;
    }
    let html_props = use_memo(()=>_.omit(rest, zbtn_classes), [rest]);
    return <Btn_comp
          {...html_props}
          disabled={hard_disabled}
          style={style}
          ref={container_ref}
          className={classname}
          onMouseEnter={on_mouse_enter}
          onMouseLeave={on_mouse_leave}
        >
          {children}
        </Btn_comp>;
});
E.Zbtn = Zbtn;

return E; }); // eslint-disable-line
